export const addNewpost = ({ state, action }) => {
  if (state.posts.ClientPost.length === 0) {
    return {
      ...state,
      posts: {
        ...state.posts,
        ClientPost: [...state.posts.ClientPost, action.payload],
      },
      loadedMember: true,
    };
  } else {
    return {
      ...state,
      posts: {
        ...state.posts,
        ClientPost: [...state.posts.ClientPost, action.payload],
      },
      loadedMember: true,
    };
  }
};
